import React, { useState, useMemo } from 'react'

import {
  Grid, Typography, IconButton, Button,
  Dialog, DialogContent, DialogActions, DialogTitle
} from '@material-ui/core'

import TreeView from '@material-ui/lab/TreeView'
import UnitTree from '../tools/UnitTree'

import CloseIcon from '@material-ui/icons/Close'

import { makeStyles } from '@material-ui/core/styles'

import { keyify2 } from '../../../utils'

const useStyles = makeStyles((theme) => ({
  dialogTitle: {},
  blueBtn: {
    backgroundColor: '#3984f7',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  },
  schoolsContent: {
    minWidth: '20em'
  },
  schoolsPaper: {
    alignItems: 'baseline'
  },
  schoolsDialog: {
    zIndex: '1050 !important'
  }
}))

/**
 * Creates a modal that displays filter information to send to ElasticSearch
 * @param {func} onFilter function called in the parent component when the Filter button is clicked
 * @param {func} onSave function called in the parent component when the Save button is clicked
 * @param {Object} treeData stored filter data based on the currently applied filter
 */
const MySchoolsModal = props => {
  const { onSave, toggleModal, open, treeData, selectedUnits } = props
  const classes = useStyles()

  // all possible units
  const data = selectedUnits && selectedUnits.length ? selectedUnits : keyify2(treeData)

  const [expandedKeys, setExpandedKeys] = useState(treeData.length ? keyify2(treeData) : [])
  const [selectedKeys, setSelectedKeys] = useState(data)

  useMemo(() => {
    if (treeData.length) setExpandedKeys(keyify2(treeData))
  }, [treeData])

  const handleUnitClick = (ancestors, key, isSelected, children) => {
    if (!isSelected) {
      const unitsToAdd = []
      let selection = []

      if (!ancestors.length) {
        selection = [key, ...keyify2(children)]
      } else {
        selection = [...ancestors, key, ...keyify2(children)]
      }

      selection.forEach((selectedKey) => {
        if (selectedKeys.findIndex((assignedUnit) => assignedUnit === selectedKey) === -1) {
          unitsToAdd.push(selectedKey)
        }
      })

      setSelectedKeys([...selectedKeys, ...unitsToAdd])
    } else {
      if (ancestors.length) {
        const tempAssigned = [...selectedKeys].filter((assignedUnit) => assignedUnit !== key)
          .filter((assignedUnit) => children.findIndex((childUnit) => childUnit.key === assignedUnit) === -1)

        setSelectedKeys([...tempAssigned])
      } else {
        setSelectedKeys([])
      }
    }
  }

  return (
    <>
      <Dialog disableEscapeKeyDown disableBackdropClick scroll='paper' className={classes.schoolsDialog} open={open} classes={{ scrollPaper: classes.schoolsPaper }}>
        <DialogTitle disableTypography>
          <Grid container direction='row' className='mx-auto w-100' justify='space-between' alignItems='center'>
            <Grid item>
              <Typography variant='h6' className={classes.dialogTitle}>Available Schools</Typography>
            </Grid>
            <Grid item>
              <IconButton className={classes.closeButton} onClick={() => toggleModal()}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>

        <DialogContent className={`${classes.schoolsContent} pl-1`}>
          <TreeView disableSelection expanded={expandedKeys}>
            <UnitTree
              treeData={treeData}
              onUnitClick={handleUnitClick}
              selectedKeys={selectedKeys}
              isCheckbox
            />
          </TreeView>
        </DialogContent>

        <DialogActions>
          <Button
            variant='contained'
            className={classes.blueBtn}
            onClick={() => onSave(selectedKeys)}
          >
            Apply
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default MySchoolsModal
